import React, { useEffect, useState } from 'react';
import CardTypeListTable from '../component/card-type/CardTypeListTable';
import CreateCardTypeModal from '../component/card-type/CreateCardTypeModal';
import { CardTypeResponse } from '../model/Card-type.model';
import CardTypeService from '../service/card-type-service/Card-type.service';
import { Spinner, TextField } from '@radix-ui/themes';
import { toast } from 'react-toastify'; // Import toast
import { Row, Col, Space } from 'antd';

const CardTypePage: React.FC = () => {
  const [cardTypeList, setCardTypeList] = useState<CardTypeResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchCardTypeList = async () => {
    setLoading(true);
    try {
      const data = await CardTypeService.getCardTypeList();
      console.log(data);
      setCardTypeList(data);
    } catch (error) {
      toast.error('Failed to fetch card types'); // Show error toast
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCardTypeList();
  }, []);

  const filteredCardTypes = cardTypeList.filter((cardType) =>
    cardType.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-2 sm:p-4 max-h-screen">
      <Row gutter={[16, 16]} className="mb-4">
        <Col
          xs={24}
          sm={12}
          md={12}
          className="flex flex-col sm:flex-row gap-2"
        >
          <Space className="w-full sm:w-auto">
            <CreateCardTypeModal onSuccess={fetchCardTypeList} />
            {/* <ExportCardTypesButton className="w-full sm:w-auto" /> */}
          </Space>
        </Col>
        <Col xs={24} sm={12} md={12}>
          <TextField.Root
            placeholder="Tìm kiếm theo tên hoặc ngân hàng"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full"
          />
        </Col>
      </Row>
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Spinner />
        </div>
      ) : (
        <div className="overflow-x-auto">
          <CardTypeListTable
            cardTypeList={filteredCardTypes}
            onSuccess={fetchCardTypeList}
          />
        </div>
      )}
    </div>
  );
};

export default CardTypePage;
